<app-page-shell [title]="'professionals_title' | translate" [description]="'professionals_desc' | translate">
  <!-- Tabs Navigation -->
  <div class="mb-6">
    <app-tabs [items]="tabs" [(activeValue)]="currentTab"></app-tabs>
  </div>

  <!-- Tab Content -->
  <div class="bg-white rounded-lg shadow p-6">
    <!-- List of Doctors Tab -->
    <app-list-of-doctors *ngIf="currentTab === 'doctors'" (newDoctor)="onNewDoctor()"
      (editDoctor)="onEditDoctor($event)">
    </app-list-of-doctors>

    <!-- Absence List Tab -->
    <app-absence-list *ngIf="currentTab === 'absences'"></app-absence-list>

    <!-- List of Shifts Tab -->
    <app-list-of-shifts *ngIf="currentTab === 'shifts'" (newShift)="onNewShift()" (editShift)="onEditShift($event)"
      (deleteShift)="onDeleteShift($event)"></app-list-of-shifts>
  </div>
</app-page-shell>

<!-- Modals -->
<app-doctor-form-modal *ngIf="showDoctorFormModal" [professional]="selectedProfessional"
  (close)="closeDoctorFormModal()" (saved)="onDoctorSaved()">
</app-doctor-form-modal>


<app-new-shift-modal *ngIf="showNewShiftModal" [shift]="selectedShift" (close)="closeNewShiftModal()"
  (saved)="onShiftSaved()">
</app-new-shift-modal>

<p-confirmDialog #cd>
  <ng-template #footer>
    <div class="flex justify-end gap-3 p-6 bg-white border-t border-slate-100">
      <app-button [label]="'NO' | translate" (onClick)="cd.onReject()" variant="secondary" styleClass="!shadow-none">
      </app-button>
      <app-button [label]="'YES' | translate" (onClick)="cd.onAccept()" variant="primary"
        styleClass="!rounded-full !px-8">
      </app-button>
    </div>
  </ng-template>
</p-confirmDialog>
<p-toast></p-toast>